import axios from 'axios';

let isRedirecting = false;

const setupAxiosInterceptors = (logout: () => void) => {
  // Request interceptor to add auth token
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor to handle 401 errors
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401 && !isRedirecting) {
        isRedirecting = true;
        
        // Clear storage and logout
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        logout();
        
        // Redirect to login
        setTimeout(() => {
          window.location.href = '/';
          isRedirecting = false;
        }, 100);
      }
      
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;